import React from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import BaseInput from 'flow/components/ui-components/BaseInput';
import { ContactFieldMaxLength } from 'flow/utils/contact-utils';

class ContactEditField extends React.PureComponent {
    static propTypes = {
        field_key: PropTypes.string.isRequired,
        field_value: PropTypes.oneOfType([
            PropTypes.instanceOf(Map),
            PropTypes.string,
        ]),
        field_func: PropTypes.func,
        label: PropTypes.string.isRequired,
        disableEdit: PropTypes.bool,
    };

    handleKeys = (event) => {
        // Prevent line breaks with enter key
        if (event.keyCode === 13) {
            event.preventDefault();
        }
    };

    getValue = () => {
        const { field_value } = this.props;

        if (Map.isMap(field_value)) {
            return field_value.get('value', null);
        }

        return typeof field_value === 'string' ? field_value : null;
    };

    /*
     * Trim the string from unwanted empty spaced in the end when finished entering a string
     */
    handleFinishedInput = (event) => {
        event.target.value = event.target.value.trimEnd();
        this.props.field_func(event);
    };

    isEditable = () => {
        const { field_value, disableEdit } = this.props;

        if (disableEdit) return false;

        if (Map.isMap(field_value) && field_value.has('editable')) {
            return field_value.get('editable');
        }

        return true;
    };

    render() {
        const { field_key, field_func, label } = this.props;

        if (!field_key) {
            return null;
        } else {
            return (
                <div className="flex flex-col justify-center gap-y-6">
                    <BaseInput
                        label={label}
                        id={field_key}
                        disabled={!this.isEditable()}
                        value={this.getValue()}
                        onChange={field_func}
                        onKeyDown={this.handleKeys}
                        onBlur={this.handleFinishedInput}
                        maxLength={ContactFieldMaxLength.get(field_key)}
                    />
                </div>
            );
        }
    }
}

export default ContactEditField;
